module.exports = __webpack_public_path__ + "img/download-2.5f04efec.png";